export default class NewsletterCreate {
  constructor($scope, NewsletterService) {
    $scope.create = function() {
      $scope.creating = true;
      NewsletterService.create($scope.newsletter).success(function(data) {
        if (data.success)
          window.location = '/admin/marketplace/newsletters';
      });
    };

    $scope.init = function() {
      $scope.newsletter = {
        title: window.newsletter_title
      };
    };

    $scope.init();
  }
}

NewsletterCreate.$inject = ['$scope', 'NewsletterService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/newsletter-create.ctrl.js